exports.name = 'Event';

exports.types = [
  'string', 'object', 'boolean', 'array', 'number', 'date'
];

exports.syskeys = [];

exports.fields = {
  name: 'string',
}
